import { BrowserRouter as Router, Routes, Route } from 'react-router-dom';
import './App.css';
import './service/css/Acp.css';
import 'bootstrap/dist/css/bootstrap.min.css';
import 'bootstrap/dist/js/bootstrap.bundle.min';
import 'bootstrap-icons/font/bootstrap-icons.css';
import LoginPage from './service/LoginPage';
import Home from './service/Home';
import Usuarios from './service/Usuarios';
import SelecionaEntidade from './service/SelecionaEntidade';
import Vinculos from './service/Vinculos';
import Entidades from './service/Entidades';

import Contratos from './service/Contratos';
import Fornecedores from './service/Fornecedores';
import Imagens from './service/Imagens';
import DescricaoEntregas from './service/DescricaoEntregas';
import Arps from './service/Arps';
import ComprasDiretas from './service/ComprasDiretas';

import SessionsAtivas from './service/SessionsAtivas';
import ElementoDespesas from './service/ElementoDespesas';
import AcaoGovernamentals from './service/AcaoGovernamentals';
import FonteRecursos from './service/FonteRecursos';
import Emissores from './service/Emissores';
import Bancos from './service/Bancos';
import NaturezaJuridicas from './service/NaturezaJuridicas';
import ParametrosEntidade from './service/ParametrosEntidade';

function App() {
  return (
    <Router>
      <Routes>
        <Route path="/" element={<LoginPage />} />
        <Route path="/home" element={<Home />} />
        <Route path="/usuarios" element={<Usuarios />} />
        <Route path="/seleciona_entidade" element={<SelecionaEntidade />} />
        <Route path="/usuario_vinculos" element={<Vinculos />} />
        <Route path="/entidades" element={<Entidades />} />

        <Route path="/contratos" element={<Contratos />} />
        <Route path="/fornecedores" element={<Fornecedores />} />
        <Route path="/imagens" element={<Imagens />} />
        <Route path="/descricao-entrega" element={<DescricaoEntregas/>} />
        <Route path="/arps" element={<Arps />} />
        <Route path="/compras-direta" element={<ComprasDiretas />} />
        <Route path="/sessions-ativas" element={<SessionsAtivas />} />
        <Route path="/elemento-despesa" element={<ElementoDespesas />} />
        <Route path="/acao-governamental" element={<AcaoGovernamentals />} />
        <Route path="/fonte-recurso" element={<FonteRecursos />} />
        <Route path="/emissores" element={<Emissores />} />
        <Route path="/bancos" element={<Bancos />} />
        <Route path="/natureza-juridica" element={<NaturezaJuridicas />} />
        <Route path="/parametros-entidade" element={<ParametrosEntidade />} />
      </Routes>
    </Router>
  );
}

export default App;
